import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../primaryComponents";
import { useBasicServiceForm } from "./useBasicServiceForm";
import secondaryComponents from "../../..";
import { useEffect } from "react";
import { CategoryGroup } from "../../../SingleProductForm/CategoryGroup";

export const BasicServiceForm = ({ formData = {}, validation = {} }) => {
  const { rootFormDetails, setRootFormDetails } = formData;
  const { sections, isLoading } = useBasicServiceForm();
  const {
    control,
    formState: { errors },
    trigger,
    setValue,
    clearErrors,
  } = validation;

  useEffect(() => {
    if (rootFormDetails?.categories?.length) clearErrors("categories");

    setValue("categories", rootFormDetails?.categories);
  }, [rootFormDetails?.categories]);

  return (
    <section className={"d-flex flex-column"}>
      <secondaryComponents.LoaderHelper
        classNames={"mt-5"}
        isLoading={isLoading}
      >
        {/* product name */}
        <primaryComponents.InputFieldV2
          name="name"
          control={control}
          placeholder={"Enter service name"}
          classNames="white"
          label="Service Name"
          value={rootFormDetails.name}
          isRequired
          errorMessage={errors?.name}
          onKeyUp={() => errors?.name && trigger("name")}
          onChange={({ target: { value } }) => {
            setRootFormDetails((prevState) => ({
              ...prevState,
              name: value,
            }));
          }}
        />

        <CategoryGroup
          validation={validation}
          rootFormDetails={rootFormDetails}
          setRootFormDetails={setRootFormDetails}
        />

        <primaryComponents.SelectFieldV2
          name="section"
          control={control}
          label="Select section"
          value={
            sections?.find((section) => section.id === rootFormDetails?.section)
              ?.name || "Select..."
          }
          options={sections}
          nameKey="name"
          idKey="id"
          classNames="w-100"
          onChange={(value) => {
            setRootFormDetails((prevState) => ({
              ...prevState,
              section: value,
            }));
          }}
          isSearchable={true}
        />

        {/* <div
          className={`${globalStyles.cardWithBorder} flex-row align-items-center justify-content-between mb-3`}
        >
          <span className="d-block">Show this service in sell mode?</span>
          <div className="d-flex align-items-center" style={{ gap: "12px" }}>
            <primaryComponents.RadioButton
              name="showOnSellMode"
              id={"showOnSellModeYes"}
              value={true}
              checked={rootFormDetails?.show_product_in_sell_mode}
              setRadioValue={() => {
                setRootFormDetails((prev) => ({
                  ...prev,
                  show_product_in_sell_mode: true,
                }));
              }}
            >
              <span>Yes</span>
            </primaryComponents.RadioButton>

            <div
              style={{
                width: "2px",
                height: "20px",
                backgroundColor: "#ccc",
              }}
            ></div>

            <primaryComponents.RadioButton
              name="showOnSellMode"
              id={"showOnSellModeNo"}
              value={false}
              checked={rootFormDetails?.show_product_in_sell_mode}
              setRadioValue={() => {
                setRootFormDetails((prev) => ({
                  ...prev,
                  show_product_in_sell_mode: false,
                }));
              }}
            >
              <span>No</span>
            </primaryComponents.RadioButton>
          </div>
        </div> */}

        <div
          className={`${globalStyles.cardWithBorder} flex-row align-items-center justify-content-between`}
        >
          <span className="d-block">
            Do you want to setup duration & availability for reservations?
          </span>
          <div className="d-flex align-items-center" style={{ gap: "12px" }}>
            <primaryComponents.RadioButton
              name="serviceDuration"
              id={"serviceDurationYes"}
              value={true}
              checked={rootFormDetails?.setup_duration}
              setRadioValue={() => {
                setRootFormDetails((prev) => ({
                  ...prev,
                  setup_duration: true,
                }));
              }}
            >
              <span>Yes</span>
            </primaryComponents.RadioButton>

            <div
              style={{
                width: "2px",
                height: "20px",
                backgroundColor: "#ccc",
              }}
            ></div>

            <primaryComponents.RadioButton
              name="serviceDuration"
              id={"serviceDurationNo"}
              value={false}
              checked={!rootFormDetails?.setup_duration}
              setRadioValue={() => {
                setRootFormDetails((prev) => ({
                  ...prev,
                  setup_duration: false,
                }));
              }}
            >
              <span>No</span>
            </primaryComponents.RadioButton>
          </div>
        </div>
      </secondaryComponents.LoaderHelper>
    </section>
  );
};
